export const FunnelStepId = Object.freeze({
  SUBSCRIPTION: 'subscription',
  SUBSCRIPTION_AMOUNT: 'subscriptionAmount',
  ACCOUNT: 'account',
  PAYMENT_FREQUENCY: 'paymentFrequency',
  DELIVERY_METHOD: 'deliveryMethod',
  GIFTED_INFO: 'giftedInfo',
  STUDENT_INFO: 'studentInfo',
  ADDRESS: 'address',
  PAYMENT_METHOD: 'paymentMethod',
  SUMMARY: 'summary',
})